import { array, struct } from 'io-ts/Decoder';

import { Id as FormulaID } from '../../../../whole-house/formula/Id';

export const Request = struct({
	formulaIds: array(FormulaID),
});
